module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isHcpView) ? _c('div', [_c('div', {
    attrs: {
      "id": "lesson-scroller"
    }
  }, [_c('mu-card', {
    attrs: {
      "align": "left"
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('mu-flexbox', [(_vm.$store.state.status.payment.paid) ? _c('mu-flexbox-item', {
    staticClass: "ellipsis",
    staticStyle: {
      "padding-left": "16px"
    },
    attrs: {
      "grow": "2"
    }
  }, [(!_vm.isLoading && _vm.currentLessonObject !== false) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.lessonScrollerWeekPrefix')))]) : _vm._e(), _c('strong', [_c('router-link', {
    attrs: {
      "to": 'lesson/' + _vm.currentLessonObject.permalink
    }
  }, [_c('span', {
    staticClass: "bold",
    domProps: {
      "textContent": _vm._s(!_vm.isLoading ? ' ' + _vm.currentLessonObject.week_name + ': ' + _vm.currentLessonObject.title : '')
    }
  })])], 1), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : '')
    }
  })]) : _vm._e(), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left",
      "disabled": _vm.isLeftLocked || _vm.isLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goLeft($event)
      }
    }
  }), _c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right",
      "disabled": _vm.isRightLocked || _vm.isLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goRight($event)
      }
    }
  })], 1)], 1)], 1), _c('mu-grid-list', {
    staticClass: "gridlist-scroller",
    attrs: {
      "cellHeight": 240,
      "id": "animationRail"
    }
  }, [_vm._l((_vm.dummyLoaders), function(loader, index) {
    return (_vm.isLoading) ? _c('mu-grid-tile', {
      key: 'loader-' + index,
      staticClass: "outerItem dummyTile"
    }, [_c('mu-linear-progress', {
      attrs: {
        "slot": "title",
        "size": 100
      },
      slot: "title"
    }), _c('mu-linear-progress', {
      attrs: {
        "slot": "subTitle"
      },
      slot: "subTitle"
    })], 1) : _vm._e()
  }), _vm._l((_vm.list), function(tile, index) {
    return _c('mu-grid-tile', {
      key: 'lesson' + index,
      staticClass: "outerItem",
      class: {
        locked: tile.status.locked === true || !_vm.$store.state.status.payment.paid
      },
      attrs: {
        "id": 'lesson' + (index + 1)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToPermalink(tile)
        }
      }
    }, [(tile.hasPersonalization) ? _c('mu-chip', {
      staticStyle: {
        "position": "absolute",
        "top": "8px",
        "right": "8px",
        "z-index": "1"
      },
      attrs: {
        "backgroundColor": "#0179d5",
        "color": "white"
      }
    }, [_vm._v(_vm._s(_vm.$t('message.labelPersonalized')))]) : _vm._e(), _c('img', {
      attrs: {
        "src": tile.image_url,
        "alt": tile.title
      }
    }), _c('span', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "textContent": _vm._s(tile.title)
      },
      slot: "title"
    }), _c('span', {
      attrs: {
        "slot": "subTitle"
      },
      domProps: {
        "textContent": _vm._s(tile.week_name.replace('Week', _vm.$t('message.labelWeek')))
      },
      slot: "subTitle"
    }), (tile.status.locked === false && _vm.$store.state.status.payment.paid) ? _c('mu-icon-button', {
      attrs: {
        "slot": "action",
        "icon": "play_arrow"
      },
      slot: "action"
    }) : _vm._e(), (tile.status.locked === true || !_vm.$store.state.status.payment.paid) ? _c('mu-icon-button', {
      attrs: {
        "slot": "action",
        "icon": "lock"
      },
      slot: "action"
    }) : _vm._e(), _vm._l((tile.bonus_modules), function(bonus, index) {
      return _c('mu-grid-tile', {
        key: "'bonus' + index",
        staticClass: "innerItem",
        class: {
          locked: tile.status.locked === true || !_vm.$store.state.status.payment.paid
        },
        attrs: {
          "slot": "action"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.goToBonus(bonus, tile)
          }
        },
        slot: "action"
      }, [_c('mu-chip', {
        staticStyle: {
          "position": "absolute",
          "top": "8px",
          "right": "8px",
          "z-index": "1"
        },
        attrs: {
          "backgroundColor": "#3d8517",
          "color": "white"
        }
      }, [_vm._v(_vm._s(_vm.$t('message.labelBonus')))]), _c('img', {
        attrs: {
          "src": bonus.image_url
        }
      }), _c('span', {
        attrs: {
          "slot": "title"
        },
        domProps: {
          "textContent": _vm._s(bonus.title)
        },
        slot: "title"
      }), _c('span', {
        attrs: {
          "slot": "subTitle"
        },
        domProps: {
          "textContent": _vm._s(bonus.subTitle.replace('Week', _vm.$t('message.labelWeek')))
        },
        slot: "subTitle"
      }), (tile.status.locked === false && _vm.$store.state.status.payment.paid) ? _c('mu-icon-button', {
        attrs: {
          "slot": "action",
          "icon": "play_arrow"
        },
        slot: "action"
      }) : _vm._e(), (tile.status.locked === true || !_vm.$store.state.status.payment.paid) ? _c('mu-icon-button', {
        attrs: {
          "slot": "action",
          "icon": "lock"
        },
        slot: "action"
      }) : _vm._e()], 1)
    })], 2)
  })], 2)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ff725fc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/LessonInlineGrid/LessonInlineGrid.vue
// module id = 3254
// module chunks = 1